interface AddIconProps {
  color?: string
}
export default function Add({ color = '#828282' }: AddIconProps) {
  return (
    <svg width="12" height="11" viewBox="0 0 12 11" fill="white" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.76056 0.878052V10.3993"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M1 5.63867H10.5213" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}
